export const manageusersData = [
  {
		id: "U461893",
		name: "Janet",
		class: "III",
		section: "A",
		dateOfJoined: "25 Mar 2024",
		status: "Active",
		key:1
	},
	{
		id: "U461892",
		name: "Joann",
		class: "IV",
		section: "B",
		dateOfJoined: "18 Mar 2024",
		status: "Active",
		key:2
	},
	{
		id: "U461891",
		name: "Kathleen",
		class: "II",
		section: "A",
		dateOfJoined: "14 Mar 2024",
		status: "Active",
		key:3
	},
	{
		id: "U461890",
		name: "Gifford",
		class: "I",
		section: "B",
		dateOfJoined: "27 Feb 2024",
		status: "Active",
		key:4
	},
	{
		id: "U461889",
		name: "Lisa",
		class: "II",
		section: "B",
		dateOfJoined: "13 Feb 2024",
		status: "Active",
		key:5
	},
	{
		id: "U461888",
		name: "Ralph",
		class: "III",
		section: "B",
		dateOfJoined: "11 Feb 2024",
		status: "Active",
		key:6
	},
	{
		id: "U461887",
		name: "Julie",
		class: "V",
		section: "A",
		dateOfJoined: "24 Jan 2024",
		status: "Active",
		key:7
	},
	{
		id: "U461886",
		name: "Ryan",
		class: "VI",
		section: "A",
		dateOfJoined: "19 Jan 2024",
		status: "Active",
		key:8
	},
	{
		id: "U461885",
		name: "Susan",
		class: "VIII",
		section: "B",
		dateOfJoined: "08 Jan 2024",
		status: "Active",
		key:9
	},
	{
		id: "U461884",
		name: "Richard",
		class: "VII",
		section: "B",
		dateOfJoined: "22 Dec 2024",
		status: "Active",
		key:10
	}
];
